import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DOData, componentVM, NJDocDefTemplate } from '../DOData';
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
    selector: 'cylib-section-list',
    templateUrl: './section-list.component.html',
    styleUrls: ['./section-list.component.css']
})
export class SectionListComponent implements OnInit {
    @Input() public loaderKey: string;
    @Input() public ignorLabel: boolean = false;

    //#region listVM
    private _listVM: Array<DOData>;
    @Input() public set listVM(ListVM: Array<DOData>) {
        this._listVM = ListVM;
    }
    public get listVM(): Array < DOData > {
            return this._listVM;
        }
    //#endregion End listVM
    public listClass: string;
    public listStyle: object;

    //#region Output events
    @Output() editItem: EventEmitter<Array<DOData>> =
        new EventEmitter<Array<DOData>>();
    @Output() clickBut: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickLink: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() clickRadio: EventEmitter<DOData> =
        new EventEmitter<DOData>();
    @Output() tabEvent: EventEmitter<componentVM> =
        new EventEmitter<componentVM>();
    //#endregion Output events

    constructor(private data: DocDefPrimLibService) { }

    ngOnInit() {
        if (this.listVM[0].customParameters['Class'] == null) {
            this.listClass = "navbar-nav";
        } else {
            this.listClass = this.listVM[0].customParameters['Class'];
        }
        if (this.listVM[0].customParameters['Styles'] == null) {
            this.listStyle = {};
        } else {
            let styles = this.data.replaceAll(this.listVM[0].customParameters['Styles'], "'", '"');
            this.listStyle = JSON.parse(styles);
        }
    }
    
    onGridClickBut(message: DOData, but: NJDocDefTemplate) {
        message.njDocDefTemplate = but;
        this.clickBut.emit(message);
    }
    onclickBut(message: DOData) {
        this.clickBut.emit(message);
    }
    onclickLink(message: DOData) {
        this.clickLink.emit(message);
    }
    onTabEvent(message: componentVM) {
        this.tabEvent.emit(message);
    }
    public editCurItem(message: Array<DOData>) {
        this.editItem.emit(message);
    }
    onclickRadio(message: DOData) {
        this.clickRadio.emit(message);
    }

}
